
























































import Vue from 'vue'
import TemplateList from '@/components/TemplateList.vue'
import ShareLinkTextField from '@/components/ShareLinkTextField.vue'
import { FeedbackRequestCreateModel } from '@/models/FeedbackRequestCreateModel'

export default Vue.extend({
  name: 'FeedbackRequestCreator',
  components: {
    TemplateList
  },
  props: {},
  data: () => ({
    isValid: true,
    notifyChecked: false,
    showCopiedConfirmation: false,
    sendMeTheLink: false,
    errorMessages: '',
    loading: false,
    feedbackRequest: {
      templateId: null,
      sharedUrl: '',
      sharedId: null,
      emails: null,
      ownersName: null,
      ownersEmail: null
    } as FeedbackRequestCreateModel,
    rules: {
      required: (value: any) => !!value || 'Required.',
      counter: (value: any) => value.length <= 20 || 'Max 20 characters',
      email: (value: any) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    }
  }),
  methods: {
    async finish (e: any) {
      if (!this.notifyChecked) {
        this.feedbackRequest.emails = null
      }
      let router = this.$router
      await this.$store
        .dispatch('createFeedbackRequest', this.feedbackRequest)
        .then(async (fr: any) => {
          if (!fr) {
            return Promise.reject(
              new Error('Oops, the feedback request could not be created.')
            )
          }
          router.replace({ name: 'feedbackresults', params: { feedbackRequestId: fr.id } })
          return Promise.resolve()
        })
    },
    handleApiCallEnd (statusCode: number) {
      this.loading = false
      if (statusCode === 401) {
        this.$store.commit('setRedirectAfterLoginUrl', this.$route.fullPath)
        this.$router.push({ name: 'login' })
      }
    }
  },
  async mounted () {
    this.loading = true
    this.$emit('sub-title-change', 'Create a feedback request')
    await this.$store
      .dispatch('getGuid')
      .then(async (guid: any) => {
        console.log(guid)
        if (!guid) {
          return Promise.reject(
            new Error('Oops, a unique id couldn\'t be generated.')
          )
        }
        console.log(this.$router.currentRoute.query)
        // TODO: update this so it can work without a window?
        this.feedbackRequest.sharedUrl = window.location.origin + '/submitfeedback/' + guid
        this.feedbackRequest.sharedId = guid
        return Promise.resolve(this.feedbackRequest.sharedUrl)
      })
  }
})
